import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instagram-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <g transform="translate(-64 -64)">
        <path
          d="M78.167,65.667a4.179,4.179,0,0,1,4.167,4.167v8.333a4.179,4.179,0,0,1-4.167,4.167H69.833a4.179,4.179,0,0,1-4.167-4.167V69.833a4.179,4.179,0,0,1,4.167-4.167h8.333m0-1.667H69.833A5.85,5.85,0,0,0,64,69.833v8.333A5.85,5.85,0,0,0,69.833,84h8.333A5.85,5.85,0,0,0,84,78.167V69.833A5.85,5.85,0,0,0,78.167,64Z"
          fill="#2acc16"
        />
        <path
          d="M170.417,130.5a1.25,1.25,0,1,1,1.25-1.25A1.247,1.247,0,0,1,170.417,130.5Zm-5.417.833a3.333,3.333,0,1,1-3.333,3.333A3.336,3.336,0,0,1,165,131.333m0-1.667a5,5,0,1,0,5,5A5,5,0,0,0,165,129.667Z"
          transform="translate(-91 -60.667)"
          fill="#2acc16"
        />
      </g>
    </svg>
  `,
  styles: [
    `
      svg {
        display: block;
      }
    `,
  ],
})
export class InstagramIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
